/* stage-log.js — Says in the console why the bubbles came, stayed away or went, on our own stage pages only.
 *
 * A bubble that vanishes "by itself" leaves no trace: every way out runs through the same retire, and the
 * corner looks the same whichever of them fired. On a stage (the demo page, data-leadwin-stage) the provider
 * and we are the audience, so the loader names the reason there (Armin 2026-10-20, a demo bubble that went
 * and stayed away after a switch between windows). A customer's website stays silent: its console is not
 * ours to write into.
 */
import { isStage } from './snippet.js';

/**
 * Writes one line about the bubbles, on a stage only.
 * @param {string} message - What happened and why, in plain words
 */
export function logBubble(message) {
    if (isStage) {
        console.info('[leadwin-agent] bubble: ' + message);
    }
}
